import React from 'react';
import {Box, styled} from '@mui/material';
import {Icon, Button} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import ErrorCircleIcon from '@/components/icons/ErrorCircle';
import LEGACY_COLORS from '@/styles/legacyColors';

const StyledErrorBanner = styled(Box)(() => ({
  'position': 'relative',
  'display': 'flex',
  'alignItems': 'center',
  'justifyContent': 'space-between',
  'backgroundColor': '#FFF6F6',
  'borderRadius': '5px',
  'filter': 'drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.1))',
  'marginTop': '10px',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '100%',
    left: '60px',
    width: 0,
    height: 0,
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderTop: '10px solid #FFF6F6',
  },
}));

const ErrorIconBox = styled(Box)(() => ({
  alignItems: 'center',
  height: '20px',
  padding: '20px 15px',
  backgroundColor: '#FFEEEE',
}));

const StyledErrorMessage = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  padding: '15px',
  color: LEGACY_COLORS.RED,
  margin: 0,
  fontSize: '14px',
  fontWeight: '400',
}));

const StyledCloseButton = styled(Button)(() => ({
  marginRight: '13px',
}));

export interface ErrorBannerProps {
  /** The error message to display */
  message: string;
  /** Callback when the error is dismissed */
  onDismiss: () => void;
}

function ErrorBanner({message, onDismiss}: ErrorBannerProps) {
  return (
    <StyledErrorBanner>
      <ErrorIconBox>
        <ErrorCircleIcon width={20} height={20} color={LEGACY_COLORS.RED} />
      </ErrorIconBox>
      <StyledErrorMessage>{translate(message)}</StyledErrorMessage>

      <StyledCloseButton
        appearance="neutral"
        mode="plain"
        size="small"
        onClick={onDismiss}
        icon={
          <Icon
            name="Actions-Close-Small"
            size="large"
            appearance="secondary"
            color={LEGACY_COLORS.GRAY_MEDIUM}
          />
        }
      />
    </StyledErrorBanner>
  );
}

export default ErrorBanner;
